import { render, staticRenderFns } from "./LayoutV3.vue?vue&type=template&id=0617a88f&"
import script from "./LayoutV3.vue?vue&type=script&lang=js&"
export * from "./LayoutV3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports